import React, { useEffect, useState } from "react";
import { ContenedorParametros } from "../../components/utils/ContenedorParametros";
import { Tooltip } from "../../components/utils/Tooltip";
import ReactTooltip from 'react-tooltip';


const clasePestania =
    "border-x border-t rounded-t-md py-2 w-[90px] bg-gray-600 flex-shrink-0 text-sm flex flex-wrap justify-center";

export const ConsultasReportes = () => {
    const [ mostrarVistaPreviaImagen, setMostrarVistaPreviaImagen ] = useState(null)


    const jsonMenus = [
        {
            nomMenu: "RP001",
            nombreReporte: "Mapa de calor de incidencias",
            vistaPrevia: "https://miniowebapi.abexacloud.com/api/Archivo/verImagen?NombreCarpeta=plamin-gestion-recursos&NombreImagen=fotos-reportes%2FRP001.PNG"
        },
        {
            nomMenu: "RP002",
            nombreReporte: "Índice de respuesta por incidencia ",
            vistaPrevia: "https://miniowebapi.abexacloud.com/api/Archivo/verImagen?NombreCarpeta=plamin-gestion-recursos&NombreImagen=fotos-reportes%2FRP002.PNG"

        },
        {
            nomMenu: "RP003",
            nombreReporte: "Perfil de horas y fechas críticas",
            vistaPrevia: "https://miniowebapi.abexacloud.com/api/Archivo/verImagen?NombreCarpeta=plamin-gestion-recursos&NombreImagen=fotos-reportes%2FRP003.PNG"

        },
        {
            nomMenu: "RP004",
            nombreReporte:"Tasa de participación por autoridad",
            vistaPrevia: "https://miniowebapi.abexacloud.com/api/Archivo/verImagen?NombreCarpeta=plamin-gestion-recursos&NombreImagen=fotos-reportes%2FRP004.PNG"

        },
        {
            nomMenu: "RP005",
            nombreReporte: "Comparativa de incidencias por distritos",
            vistaPrevia: "https://miniowebapi.abexacloud.com/api/Archivo/verImagen?NombreCarpeta=plamin-gestion-recursos&NombreImagen=fotos-reportes%2FRP005.PNG"
        },
        {
            nomMenu: "RP006",
            nombreReporte: "Indicador de respueta preventiva",
            vistaPrevia: "https://cdn-icons-png.flaticon.com/256/1312/1312175.png"
        },
        {
            nomMenu: "RP007",
            nombreReporte: "Comparativa de incidencias por distritos",
            vistaPrevia: "https://cdn-icons-png.flaticon.com/256/1312/1312175.png"
        },
        {
            nomMenu: "RP008",
            nombreReporte: "Analisis de incidentes recurrentes",
            vistaPrevia: "https://cdn-icons-png.flaticon.com/256/1312/1312175.png"
        },
        {
            nomMenu: "RP009",
            nombreReporte: "Tendencias de seguridad ciudadana mensuales",
            vistaPrevia: "https://cdn-icons-png.flaticon.com/256/1312/1312175.png"
        },

        {
            nomMenu: "RP010",
            nombreReporte: "Frecuencia de Incidencias en zonas comerciales",
            vistaPrevia: "https://cdn-icons-png.flaticon.com/256/1312/1312175.png"
        },
        {
            nomMenu: "RP011",
            nombreReporte: "Análisis de alertas por acoso",
            vistaPrevia: "https://cdn-icons-png.flaticon.com/256/1312/1312175.png"
        },
        {
            nomMenu: "RP012",
            nombreReporte: "Informe de seguridad en transporte urbano",
            vistaPrevia: "https://cdn-icons-png.flaticon.com/256/1312/1312175.png"
        },        {
            nomMenu: "RP013",
            nombreReporte: "Impacto de intervenciones en zonas de riesgo",
            vistaPrevia: "https://cdn-icons-png.flaticon.com/256/1312/1312175.png"
        },

        {
            nomMenu: "RP014",
            nombreReporte: "Evolución de indice de seguridad Percepción ciudadana",
            vistaPrevia: "https://cdn-icons-png.flaticon.com/256/1312/1312175.png"
        },
        {
            nomMenu: "RP015",
            nombreReporte: "Análisis de efectividad de patrullaje por agentes",
            vistaPrevia: "https://cdn-icons-png.flaticon.com/256/1312/1312175.png"
        },      
        {
            nomMenu: "RP016",
            nombreReporte: "Reporte general de alertas",
            vistaPrevia: "https://cdn-icons-png.flaticon.com/256/1312/1312175.png"
        },      
    ];

    const [menuActual, setMenuActual] = useState("HOME");
    const [menusAbiertos, setMenusAbiertos] = useState([]);
    const [componentes, setComponentes] = useState([]);

    useEffect(() => {
        cargarComponentes();
    }, []);

    const funcionAbrirMenu = (nombreMenu) => {
        if (!menusAbiertos.some((elem) => elem == nombreMenu)) {
            setMenuActual(nombreMenu);
            setMenusAbiertos((arrAnterior) => {
                return [...arrAnterior, nombreMenu];
            });
        }
    };

    const cargarComponentes = async () => {
        const nuevosComponentes = await Promise.all(
            jsonMenus.map(async (data) => {
                try {
                    const modulo = await import(
                        `./VistaReportes/${data.nomMenu}`
                    );
                    return {
                        nomMenu: data.nomMenu,
                        nomReporte: data.nombreReporte,
                        componente: modulo.default,
                        error: null, // No hay error
                    };
                } catch (error) {
                    // CUANDO NO TRAE NADA EL IMPORT
                    console.error(`Error importing ${data.nomMenu}:`, error);
                    return {
                        nomMenu: data.nomMenu,
                        nomReporte: data.nombreReporte,
                        componente: null,
                        error: error.message, // Mensaje de error
                    };
                }
            })
        );
        setComponentes(nuevosComponentes);
    };

    return (
        <>
            <div className="overflow-auto flex-grow flex flex-col mt-2">
                <div className="flex gap-1">
                    <button
                        className={`${clasePestania} ${
                            menuActual == "HOME" ? "!bg-blue-600" : ""
                        }`}
                        onClick={() => setMenuActual("HOME")}
                    >
                        HOME
                    </button>
                    {menusAbiertos.map((nombreMenu, i) => (
                        <button
                            key={i + 1}
                            className={`${clasePestania} relative ${
                                menuActual == nombreMenu ? "!bg-blue-600" : ""
                            }`}
                            onClick={() => setMenuActual(nombreMenu)}
                        >
                            <span>{nombreMenu}</span>
                            <div
                                onClick={(event) => {
                                    event.stopPropagation(); // EVITA QUE SE EJECUTE EL ONCLICK DEL BOTON
                                    setMenuActual("HOME");
                                    setMenusAbiertos((arrAnterior) => {
                                        const arrCopia = [...arrAnterior];
                                        return arrCopia.filter(
                                            (e) => e != nombreMenu
                                        );
                                    });
                                }}
                                className="absolute z-10 top-0 right-0 rounded-full w-[16px] h-[16px] flex items-center justify-center bg-red-600 hover:scale-105"
                            >
                                <i
                                    className="fa fa-times text-[10px]"
                                    aria-hidden="true"
                                ></i>
                            </div>
                        </button>
                    ))}
                </div>
                <div className="flex-grow overflow-auto border border-gray-500 p-2 flex flex-col">
                    {/* MENU HOME */}
                    <div
                        className={`${
                            menuActual == "HOME" ? "" : "hidden"
                        } w-full h-full overflow-auto containerScroll flex flex-col p-6`}
                    >
                        <table className="table">
                            <thead>
                                <tr>
                                    <th className="text-left">Nº</th>
                                    <th className="text-left">CÓDIGO</th>
                                    <th className="text-left">TÍTULO</th>
                                    <th className="text-left">NOMBRE</th>
                                    <th className="text-left">Vista Previa</th>
                                </tr>
                            </thead>
                            <tbody>
                                {jsonMenus.map((data, i) => {
                                    return (
                                        <tr
                                            key={i + 1}
                                            onClick={() =>
                                                funcionAbrirMenu(data.nomMenu)
                                            }
                                            className={`${
                                                menusAbiertos.some(
                                                    (e) => e == data.nomMenu
                                                )
                                                    ? "!bg-[#5985eb]"
                                                    : ""
                                            }`}
                                        >
                                            <td className="text-left">
                                                {i + 1}
                                            </td>
                                            <td className="text-left">
                                                {data.nomMenu}
                                            </td>
                                            <td className="text-left">
                                                {data.nombreReporte}
                                            </td>
                                            <td className="text-left">
                                                {data.nombreReporte}
                                            </td>
                                            <td className="text-left">
                                                <img className="w-8 " src={data.vistaPrevia} alt=""
                                                    data-tip=''
                                                    data-for={`${data.nombreReporte}`}

                                                    />
                                                <ReactTooltip id={`${data.nombreReporte}`} place="top" effect="solid">
                                                    <div>
                                                        <img className="z-50 w-[300px]" src={data.vistaPrevia} alt={data.nombreReporte} />
                                                    </div>
                                                </ReactTooltip>

                                                <Tooltip id={`${data.nombreReporte}`}></Tooltip>

                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                    {/* MENUS RESTANTES */}
                    {componentes.map(
                        (
                            {
                                nomMenu: nomMenu,
                                nomReporte: nombreReporte,
                                componente: ComponenteDinamico,
                            },
                            i
                        ) =>
                            menuActual == nomMenu ? (
                                <div
                                    key={i + 1}
                                    className={`${
                                        menuActual == nomMenu ? "" : "hidden"
                                    } w-full h-full flex-grow flex flex-col`}
                                >
                                    <ComponenteDinamico
                                        nombreReporte={nombreReporte}
                                    />
                                </div>
                            ) : (
                                <React.Fragment key={i + 1}></React.Fragment>
                            )
                    )}
                </div>
            </div>
        </>
    );
};
